import { useEffect, useState } from "react";
import { RotateCcw, Smartphone } from "lucide-react";
import type { Language } from "../types/game";
import { tr } from "../systems/i18n";
import { Crest } from "./ui";

export function LandscapeGate({ language }: { language: Language }) {
  const [blocked, setBlocked] = useState(false);
  useEffect(() => {
    const check = () => setBlocked(window.innerWidth < 900 && window.innerHeight > window.innerWidth);
    check();
    window.addEventListener("resize", check);
    window.addEventListener("orientationchange", check);
    return () => { window.removeEventListener("resize", check); window.removeEventListener("orientationchange", check); };
  }, []);
  if (!blocked) return null;
  return <div className="landscape-gate" role="alertdialog" aria-modal="true">
    <div className="landscape-gate__glow" />
    <Crest size="lg" />
    <div className="rotate-device"><Smartphone size={46} /><RotateCcw size={28} /></div>
    <h1>{tr(language, "rotateTitle")}</h1>
    <p>{tr(language, "rotateText")}</p>
  </div>;
}
